<!-- 商户订单/商户订单列表 -->
<template>
  <el-table :data="tableData" style="width: 100%;border: 1px solid #f1f1f1">
    <el-table-column
      sortable
      label="编号"
      align="center"
      prop="id"
      width="80"
    ></el-table-column>
    <el-table-column
      label="订单号"
      prop="ordersn"
      align="center"
    ></el-table-column>
    <el-table-column
      label="会员名"
      prop="vipname"
      align="center"
    ></el-table-column>
    <el-table-column label="商户" prop="name" align="center"></el-table-column>
    <el-table-column
      label="商户信息"
      prop="shopsName"
      align="center"
    ></el-table-column>
    <el-table-column label="收货信息" align="center">
      <template slot-scope="scope">
        <div class="table_scope_line">收货人姓名：{{ scope.row.xyf }}</div>
        <div class="table_scope_line">收货人手机号：{{ scope.row.xyjb }}</div>
      </template>
    </el-table-column>
    <el-table-column label="应付金额" align="center">
      <template slot-scope="scope">
        <div class="table_scope_line">{{ scope.row.price }}</div>
        <div class="table_scope_line" v-if="true">
          含运费：{{ scope.row.xyjb }}
        </div>
      </template>
    </el-table-column>
    <el-table-column label="状态" prop="state" align="center"></el-table-column>
    <el-table-column label="操作" align="center">
      <template slot-scope="scope">
        <div class="table_button_line">
          <el-button type="text" @click="detail(scope.row.id)">查看</el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    detail(id) {
      console.log(id);
    }
  }
};
</script>
